/* Moringa Patch landing — vanilla JS, no dependencies */
(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  /* ---------- gallery ---------- */
  function initGallery(root){
    const slides = $('#slides', root); if (!slides || slides.dataset.ready) return;
    slides.dataset.ready = 1;
    const imgs = $$('img', slides), dots = $$('#dots i', root), thumbs = $$('#thumbs button', root), count = $('#gCount', root);
    let cur = 0;
    const goTo = i => { cur = (i + imgs.length) % imgs.length; slides.scrollTo({left: -cur * slides.clientWidth, behavior:'smooth'}); };
    const mark = i => {
      cur = i;
      dots.forEach((d,k) => d.classList.toggle('on', k === i));
      thumbs.forEach((t,k) => t.classList.toggle('on', k === i));
      if (thumbs[i]) thumbs[i].scrollIntoView({behavior:'smooth', block:'nearest', inline:'center'});
      if (count) count.textContent = `${i + 1} / ${imgs.length}`;
    };
    slides.addEventListener('scroll', () => mark(Math.round(Math.abs(slides.scrollLeft) / slides.clientWidth)), {passive:true});
    const n = $('#gNext', root), p = $('#gPrev', root);
    if (n) n.onclick = () => goTo(cur + 1);
    if (p) p.onclick = () => goTo(cur - 1);
    thumbs.forEach((t,i) => t.onclick = () => goTo(i));
  }

  /* ---------- offers + order button ---------- */
  function initOffers(root){
    const list = $('#offerList', root), btn = $('#orderBtn', root);
    if (!list || list.dataset.ready) return;
    list.dataset.ready = 1;
    const offers = $$('.offer', list);
    const txt = btn && $('#orderTxt', btn);
    let current = null;
    /* keep the hidden product form (used by COD / upsell apps) in sync with the chosen offer */
    const form = $('[data-mp-form]', root) || $('.mp-sync-form', root);
    const fire = (n, type) => { n.dispatchEvent(new Event(type, {bubbles:true})); };
    const sync = el => {
      const variant = el.dataset.variant, qty = el.dataset.qty || '1';
      if (form){
        let idEl = form.querySelector('[name="id"]');
        if (!idEl){ idEl = document.createElement('input'); idEl.type = 'hidden'; idEl.name = 'id'; form.appendChild(idEl); }
        let qEl = form.querySelector('[name="quantity"]');
        if (!qEl){ qEl = document.createElement('input'); qEl.type = 'hidden'; qEl.name = 'quantity'; form.appendChild(qEl); }
        if (variant) idEl.value = variant;
        qEl.value = qty;
        [idEl, qEl].forEach(n => { fire(n, 'input'); fire(n, 'change'); });
        fire(form, 'change');
      }
      if (variant && /\/products\//.test(location.pathname)){
        try { const u = new URL(location.href); u.searchParams.set('variant', variant); history.replaceState(null, '', u); } catch(e){}
      }
      document.dispatchEvent(new CustomEvent('mp:offer-change', {detail:{variant, quantity:+qty, price:el.dataset.price}}));
    };
    const pick = el => {
      current = el;
      offers.forEach(o => { const on = o === el; o.classList.toggle('on', on); o.setAttribute('aria-checked', on); });
      if (!el) return;
      sync(el);
      if (!btn) return;
      const label = btn.dataset.text || '';
      txt.textContent = btn.dataset.showPrice === 'true' && el.dataset.price
        ? `${label} · ${el.dataset.price} ${btn.dataset.currency || ''}`.trim()
        : label;
      if (btn.dataset.action === 'url' && btn.dataset.url){
        const sep = btn.dataset.url.includes('?') ? '&' : '?';
        btn.href = `${btn.dataset.url}${sep}qty=${el.dataset.qty}&variant=${el.dataset.variant}`;
      }
      btn.dataset.variant = el.dataset.variant;
      btn.dataset.qty = el.dataset.qty;
    };
    list.addEventListener('click', e => { const c = e.target.closest('.offer'); if (c) pick(c); });
    list.addEventListener('keydown', e => {
      const c = e.target.closest('.offer');
      if (c && (e.key === 'Enter' || e.key === ' ')){ e.preventDefault(); pick(c); }
    });
    pick(offers.find(o => o.hasAttribute('data-default')) || offers[0] || null);

    if (btn) btn.addEventListener('click', async e => {
      const action = btn.dataset.action;
      if (action === 'url' || action === 'none') { if (action === 'none') e.preventDefault(); return; }
      e.preventDefault();
      if (!current || !current.dataset.variant){ location.href = '/cart'; return; }
      btn.style.pointerEvents = 'none'; btn.style.opacity = '.75';
      try {
        if (btn.dataset.clear === 'true') await fetch('/cart/clear.js', {method:'POST', headers:{'Content-Type':'application/json'}});
        const r = await fetch('/cart/add.js', {
          method:'POST', headers:{'Content-Type':'application/json', 'Accept':'application/json'},
          body: JSON.stringify({items:[{id:+current.dataset.variant, quantity:+current.dataset.qty || 1}]})
        });
        if (!r.ok) throw new Error(await r.text());
        location.href = action === 'cart' ? '/cart' : '/checkout';
      } catch(err){
        console.error('[mp] add to cart failed', err);
        btn.style.pointerEvents = ''; btn.style.opacity = '';
        location.href = '/cart';
      }
    });
  }

  /* ---------- delivery estimate ---------- */
  function initShip(root){
    const ship = $('#ship', root); if (!ship) return;
    const add = n => { const d = new Date(); d.setDate(d.getDate() + n); return d; };
    const day = d => d.toLocaleDateString('ar-MA', {weekday:'long'});
    const date = d => d.toLocaleDateString('ar-MA', {day:'numeric', month:'long'});
    const d1 = add(+ship.dataset.prep || 0), d2 = add(+ship.dataset.del || 0);
    const set = (id, v) => { const el = $(id, ship); if (el) el.textContent = v; };
    set('#d0', date(new Date()));
    set('#d1n', day(d1)); set('#d1', date(d1));
    set('#d2n', day(d2)); set('#d2', date(d2));
  }

  /* ---------- reviews ---------- */
  function initReviews(root){
    const revs = $('#revs', root); if (!revs || revs.dataset.ready) return;
    revs.dataset.ready = 1;
    const cards = $$('.rv', revs), dots = $$('#rvDots i', root), more = $('#rvMore', root);
    const markRv = () => {
      if (!cards.length) return;
      const w = cards[0].offsetWidth + 12;
      const i = Math.min(cards.length - 1, Math.round(Math.abs(revs.scrollLeft) / w));
      dots.forEach((d,k) => d.classList.toggle('on', k === i));
    };
    revs.addEventListener('scroll', markRv, {passive:true});
    const visible = +getComputedStyle(revs).getPropertyValue('--rv-visible') || 6;
    cards.forEach((c,i) => c.classList.toggle('rv-x', i >= visible));
    if (more){
      more.onclick = () => {
        const open = revs.classList.toggle('clamp') === false;
        more.classList.toggle('open', open);
        $('span', more).textContent = open ? more.dataset.less : more.dataset.more;
        if (!open) revs.closest('section').scrollIntoView({behavior:'smooth', block:'start'});
      };
    }
    markRv();
  }

  /* ---------- ingredients ---------- */
  function initIngredients(root){
    const btn = $('#more', root); if (!btn || btn.dataset.ready) return;
    btn.dataset.ready = 1;
    const visible = +btn.dataset.visible || 5;
    btn.onclick = () => {
      const open = btn.classList.toggle('open');
      $$('#ings li', root).forEach((li,i) => i >= visible && li.classList.toggle('more-hide', !open));
      $('span', btn).textContent = open ? btn.dataset.less : btn.dataset.more;
    };
  }

  /* ---------- before / after ---------- */
  function initBA(root){
    const frame = $('#baFrame', root); if (!frame || frame.dataset.ready) return;
    frame.dataset.ready = 1;
    const range = $('#baRange', frame);
    const tagB = $('.ba-tag-b', frame), tagA = $('.ba-tag-a', frame);
    const start = +frame.dataset.start || 50;
    const set = v => {
      v = Math.max(0, Math.min(100, +v));
      frame.style.setProperty('--pos', v + '%');
      range.value = Math.round(v);
      if (tagB) tagB.style.opacity = v < 16 ? 0 : 1;
      if (tagA) tagA.style.opacity = v > 84 ? 0 : 1;
    };
    range.addEventListener('input', e => set(e.target.value));
    let drag = false, user = false;
    const at = e => { const r = frame.getBoundingClientRect(); set((e.clientX - r.left) / r.width * 100); };
    frame.addEventListener('pointerdown', e => {
      drag = user = true; frame.classList.add('drag');
      frame.setPointerCapture(e.pointerId); at(e); range.focus({preventScroll:true});
    });
    frame.addEventListener('pointermove', e => drag && at(e));
    ['pointerup','pointercancel','lostpointercapture'].forEach(t =>
      frame.addEventListener(t, () => { drag = false; frame.classList.remove('drag'); }));
    set(start);
    const io = new IntersectionObserver(([e]) => {
      if (!e.isIntersecting) return; io.disconnect();
      if (reduce) return;
      const t0 = performance.now() + 300;
      const tick = now => {
        if (user) return;
        const t = (now - t0) / 1400;
        if (t < 0) return requestAnimationFrame(tick);
        if (t >= 1) return set(start);
        set(start + Math.sin(t * Math.PI * 2) * 14);
        requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    }, {threshold:.6});
    io.observe(frame);
  }

  /* ---------- timeline scroll progress ---------- */
  const timelines = new Set();
  function initTimeline(root){
    const tl = $('#time', root); if (tl) timelines.add(tl);
    updateTimelines();
  }
  function updateTimelines(){
    const mid = innerHeight * 0.6;
    timelines.forEach(tl => {
      if (!tl.isConnected){ timelines.delete(tl); return; }
      const r = tl.getBoundingClientRect();
      const p = Math.max(0, Math.min(1, (mid - r.top - 10) / Math.max(1, r.height - 20)));
      tl.style.setProperty('--p', p.toFixed(3));
      [...tl.children].forEach(s => s.classList.toggle('on', s.getBoundingClientRect().top + 14 <= mid));
    });
  }
  let ticking = false;
  addEventListener('scroll', () => { if (!ticking){ ticking = true; requestAnimationFrame(() => { ticking = false; updateTimelines(); }); } }, {passive:true});
  addEventListener('resize', updateTimelines);

  /* ---------- announcement carousel ---------- */
  function initAnn(root){
    const ann = root.matches && root.matches('[data-mp-ann]') ? root : $('[data-mp-ann]', root);
    if (!ann || ann.dataset.ready) return;
    ann.dataset.ready = 1;
    const msgs = $$('.ann-msg', ann); if (msgs.length < 2) return;
    let i = 0, timer;
    const show = n => { msgs[i].classList.remove('on'); i = (n + msgs.length) % msgs.length; msgs[i].classList.add('on'); };
    const auto = () => { clearInterval(timer); timer = setInterval(() => show(i + 1), +ann.dataset.speed || 3500); };
    const nx = $('[data-ann-next]', ann), pv = $('[data-ann-prev]', ann);
    if (nx) nx.onclick = () => { show(i + 1); auto(); };
    if (pv) pv.onclick = () => { show(i - 1); auto(); };
    if (!reduce) auto();
  }

  /* ---------- menu active state ---------- */
  let spy;
  function initMenu(){
    const links = $$('[data-mp-menu] a'); if (!links.length) return;
    if (spy) spy.disconnect();
    spy = new IntersectionObserver(entries => entries.forEach(e => {
      if (!e.isIntersecting) return;
      links.forEach(a => a.classList.toggle('on', a.getAttribute('href') === '#' + e.target.id));
    }), {rootMargin:'-45% 0px -50% 0px'});
    links.forEach(a => {
      const h = a.getAttribute('href') || '';
      if (h.startsWith('#') && h.length > 1){ const s = document.getElementById(h.slice(1)); if (s) spy.observe(s); }
    });
  }

  /* ---------- reveal ---------- */
  const rv = new IntersectionObserver(es => es.forEach(e => {
    if (e.isIntersecting){ e.target.classList.add('in'); rv.unobserve(e.target); }
  }), {threshold:.12});
  function initReveal(root){
    $$('.reveal', root).forEach(el => {
      if (window.Shopify && Shopify.designMode) el.classList.add('in');
      else rv.observe(el);
    });
  }

  function init(root = document){
    initAnn(root); initGallery(root); initOffers(root); initShip(root);
    initReviews(root); initIngredients(root); initBA(root); initTimeline(root);
    initReveal(root); initMenu();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();

  /* theme editor */
  document.addEventListener('shopify:section:load', e => init(e.target));
  document.addEventListener('shopify:block:select', e => {
    const offer = e.target.closest && e.target.closest('.offer');
    if (offer) offer.click();
    const rev = e.target.closest && e.target.closest('#revs');
    if (rev) rev.classList.remove('clamp');
    if (e.target.matches && e.target.matches('.ann-msg')){
      $$('.ann-msg', e.target.parentNode).forEach(m => m.classList.toggle('on', m === e.target));
    }
  });
})();
